import { SingleOperation } from "./Operation";
import { Verb } from "../types/Verb";
import {
  WBEventDeleteSubjectPayload,
  WBEventUpsertSubjectAttributeManyPayload,
} from "../types/WBEvent2";
import { ShapeStore } from "../ShapeStore";

export class DeleteOperation extends SingleOperation {
  subjectIDs: string[];

  constructor(subjectIDs: string[], shapeStore: ShapeStore) {
    const backwardEvents: WBEventUpsertSubjectAttributeManyPayload[] =
      subjectIDs.map((s) => {
        return {
          verb: Verb.UpsertSubjectAttributeMany,
          subjectID: s,
          version: -1,
          attributes: shapeStore.getAttributes(s),
        };
      });

    const forwardEvents: WBEventDeleteSubjectPayload[] = subjectIDs.map((s) => {
      return {
        verb: Verb.DeleteShape,
        subjectID: s,
      };
    });

    super(forwardEvents, backwardEvents);
    this.subjectIDs = subjectIDs;
  }

  get label(): string {
    if (this.subjectIDs.length == 1) {
      return `Delete ${this.subjectIDs.length} shape`;
    } else {
      return `Delete 1 shape`;
    }
  }
}
